import React from 'react';
import { Sprite } from '@agissc/ktag-map';
import { useTranslation } from 'react-i18next';
import useAppState from '../../AppStore';
import { useWmsLegendQuery } from '../mapContent/api/useWmsLegendQuery';
import LegendItem from './LegendItem';
import LegendItemPlaceholder from './LegendItemPlaceholder';

interface WmsLegendProps {
  layerName: string;
}

const WmsLegend = ({ layerName }: WmsLegendProps) => {
  const location = useAppState((state) => state.location);
  const legendData = useWmsLegendQuery(layerName, location.resolution);
  const { t } = useTranslation('agisviewer');

  if (legendData.isLoading) return <LegendItemPlaceholder />;

  const legend = legendData.data?.map((item, i) => {
    return {
      id: `${layerName}-${i}`,
      label: item.label,
      image: item.blob,
    };
  });

  if (!legend)
    return (
      <p>
        <Sprite id="i-circle" additionalClassNames="legend__icon" />{' '}
        {t('scaled_legend_wms')}
      </p>
    );

  return (
    <div>
      {legend.map((item) => (
        <LegendItem key={item.id} label={item.label} image={item.image} />
      ))}
    </div>
  );
};

export default WmsLegend;
